import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

import { StayType } from '__generated__/api';

export const getStayTypeInput = (searchCriteria: SearchCriteriaModel): StayType[] | null => {
  if (searchCriteria.stayType && searchCriteria.stayType.length > 0) {
    return searchCriteria.stayType
      .map(type => {
        const result = StayType[StayType[type]];

        return result ? result : null;
      })
      .filter(type => type !== null);
  }

  return null;
};
